import { useEffect, useState } from 'react';
import { useRoute, useLocation } from 'wouter';
import { useGame } from '../../stores/game';
import ServiceScreen from '../service-screen';

interface IProps {
  children: JSX.Element | JSX.Element[];
}

export const Initializer = ({ children }: IProps): JSX.Element => {
  const init = useGame(({ init }) => init);
  const isInitialized = useGame(({ isInitialized }) => isInitialized);
  const isStarted = useGame(({ isStarted }) => isStarted); // ← Aggiungi questo

  const [location] = useLocation();
  console.log('>>> Initializer - component rendered');
  console.log('>>> Current Location:', location);
  const [isReady, setReady] = useState<boolean>(false);

  const [, params] = useRoute<{ gamePlayId: string }>(
    '/games/:gamePlayId/:rest*'
  );
  const gamePlayIdInUse: string = params?.gamePlayId;
  console.log('>>> gamePlayIdInUse', gamePlayIdInUse);
  console.log('>>> params', params);
  console.log('>>> isStarted from store:', isStarted); // ← Log per debug

  useEffect(() => {
    if (!gamePlayIdInUse) return;

    useGame.persist.setOptions({ name: `hospitalia-${gamePlayIdInUse}` });

    useGame.persist.rehydrate().then(() => {
      init({
        gamePlayId: gamePlayIdInUse,
      }).then(() => {
        // Non settare ready qui, aspetta che isStarted venga aggiornato
        console.log('>>> Init completed, waiting for game snapshot...');
      });
    });
  }, [gamePlayIdInUse]);

  // ← NUOVO: Aspetta che isStarted sia stato caricato
  useEffect(() => {
    if (isInitialized && isStarted !== undefined) {
      console.log('>>> Game data loaded, isStarted:', isStarted);
      setReady(true);
    }
  }, [isInitialized, isStarted]);

  // If everything is ready, render the children.
  if (isReady) return <>{children}</>;

  // If we're not ready, and no game id was retrieved, then we're should not be
  // here.
  if (!gamePlayIdInUse) return <ServiceScreen text="Invalid link." />;

  return <ServiceScreen text="Loading game data..." />; // ← Mostra loading
};
